import React, { Component, ComponentType, createRef, RefObject } from 'react';
import StateManager from 'react-select';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { queueMacrotask } from 'utils/macrotask';

type KnownProps<T> = {
  selectRef: RefObject<StateManager>;
  onChange: (next: T) => void;
};

export const withFocusableSelect = <T, P extends KnownProps<T>>(
  OriginalComponent: ComponentType<P>,
) =>
  setDisplayName(wrapDisplayName(OriginalComponent, 'withFocusableSelect'))(
    class extends Component<Omit<P, 'selectRef'>> {
      selectRef = createRef<StateManager>();

      componentDidMount(): void {
        this.focus();
      }

      focus = () => {
        this.selectRef.current?.focus();
      };

      private _onChange = (next: T) => {
        const { onChange } = this.props;

        onChange(next);
        queueMacrotask(() => {
          this.selectRef.current?.blur();
          this.selectRef.current?.focus();
        });
      };

      render() {
        const { selectRef, _onChange, props } = this;

        return (
          <OriginalComponent
            selectRef={selectRef}
            {...(props as any)}
            onChange={_onChange}
          />
        );
      }
    },
  );
